// GENERATED by api/scripts/iq-fields-from-openapi.py — do not edit by hand.
// Source: iQ OpenAPI spec (Account Management Portal (Sandbox)).

/** iQ field paths per record type, from the iQ API spec. */
export const IQ_SPEC_FIELDS = {
  "customer": [
    "Code",
    "Name",
    "TradingName",
    "Address",
    "Address.AddressLine1",
    "Address.AddressLine2",
    "Address.AddressLine3",
    "Address.City",
    "Address.County",
    "Address.PostCode",
    "Address.Country",
    "Phone",
    "EmailAddress",
    "WorkflowStatus",
    "WorkflowStatus.Code",
    "WorkflowStatus.Description",
    "DefaultCurrency",
    "DefaultCurrency.Code",
    "DefaultCurrency.Description",
    "PostingMap",
    "PostingMap.Code",
    "PostingMap.Description",
    "Type",
    "Type.Code",
    "Type.Description",
    "SalesRep",
    "SalesRep.Code",
    "SalesRep.Name",
    "NetSalesAccount",
    "NetSalesAccount.Code",
    "NetSalesAccount.Description",
    "Contacts",
    "CompanyRegistration",
    "TaxSetup",
    "TaxSetup.DefaultTaxRate",
    "TaxSetup.TaxRegistrationNumber",
    "TaxSetup.D_TSSCode",
    "TaxSetup.EoriNumber",
    "InvoiceRunSetup",
    "InvoiceRunSetup.InvoiceRunGroup",
    "PrinterFormContactInfo",
    "CliQxCustomerExtension",
    "CliQxCustomerExtension.StoreAvailability",
    "CliQxCustomerExtension.Items",
    "CreditControlSetup",
    "CreditControlSetup.CreditLimit",
    "CreditControlSetup.CreditTermDefault",
    "Region",
    "Region.Code",
    "Region.Description"
  ],
  "supplier": [
    "Code",
    "Name",
    "TradingName",
    "Phone",
    "EmailAddress",
    "HomePage",
    "Type",
    "Type.Code",
    "Type.Description",
    "CreditControlSetup",
    "CreditControlSetup.CreditTermDefault",
    "BankAccountDetails",
    "BankAccountDetails.BankName",
    "BankAccountDetails.AccountName",
    "BankAccountDetails.AccountNumber",
    "BankAccountDetails.BIC",
    "BankAccountDetails.IBAN",
    "BankAccountDetails.SortCode",
    "Contacts",
    "PickupContacts",
    "DefaultCurrency",
    "DefaultCurrency.Code",
    "DefaultCurrency.Description",
    "PostingMap",
    "PostingMap.Code",
    "PostingMap.Description",
    "NetPurchasesAccount",
    "NetPurchasesAccount.Code",
    "NetPurchasesAccount.Description",
    "TaxSetup",
    "TaxSetup.DefaultTaxRate",
    "TaxSetup.TaxRegistrationNumber",
    "Address",
    "Address.AddressLine1",
    "Address.AddressLine2",
    "Address.AddressLine3",
    "Address.City",
    "Address.County",
    "Address.PostCode",
    "Address.Country",
    "CompanyRegistration"
  ],
  "lead": [
    "Name",
    "SalesRep",
    "SalesRep.Code",
    "SalesRep.Name"
  ]
} as const;
